<template>
  <div class="sticky-menu" :class="{'mobile': isMobile}">
    <nav class="grid" :class="{'light': image == 'light'}">
      <div class="unit two-thirds">
        <a href="/">
          <img class="logo before" src="~@/assets/img/logo-nav-new.png" />
          <img class="logo after" src="~@/assets/img/logo-nav-new.png" />
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import Vue from 'vue'
import Modal from '@/comps/Modal'
import Anchor from '@/comps/Anchor'

function isQueryParam (key) {
  const regex = `[?&]${key}` // if key is present, preceded by either '&' or '?'
  return !!location.search.match(regex)  // check in URL query, return a Boolean
}

const showSignup = isQueryParam('signup')
const formSubmitted = isQueryParam('submissionGuid') // will be available only after the signup form has been submitted

const setupScrollAnimation = function () {

    const menu = document.getElementsByClassName('sticky-menu')[0]
    const height = document.body.scrollHeight - window.innerHeight

    window.onscroll = function () {
      if((window.pageYOffset / height) * 100 >= 1) {
        menu.classList.add('smaller')
      } else {
        menu.classList.remove('smaller')
      }
    }
}

export default {
  name: 'headr',
  components: { Modal, Anchor },
  props: {
    base: {
      type: String,
      default: '',
    },
    home: {
      type: Boolean,
    },
    image: {
      type: String,
      default: 'white',
    },
  },
  mounted () {
    setupScrollAnimation()
    const signupModal = this.$refs.signup

    window.onresize = () => {
      this.isMobile = window.innerWidth <= 950
    }

    window.onpopstate = ({ state }) => { // forward and back events on browser
      if(state && state.showSignupPopup) {
        this.$signupModal.open()
      } else if(showSignup) { // only if popup was open.
        this.$signupModal.close()
      }
    }

    if(showSignup && !formSubmitted) {
      this.$signupModal.open()
    } else if(formSubmitted) {
      this.$signupModal.thanks()
    }
  },
  data () {
    return {
      showMenu: false,
      isMobile: window.innerWidth <= 950,
    }
  },
  computed: {
    darkLogoSrc () {
      return require('@/assets/img/archii-dark-' + this.image + '.svg')
    }
  },
  methods: {
    openSignupModal () {
      this.$signupModal.open()
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/vars.scss';

.sticky-menu {
  top: 0;
  left: 0;
  z-index: 1;
  position: fixed;
  padding: 10px 40px;
  width: calc(100% - 80px);
  background-color: rgba(39, 69, 131, 0);
  transition: all 0.2s ease;

  .logo.before {
    display: inline-block;
  }

  .logo.after {
    display: none;
  }

  .burger {
    float: right;
    padding: 10px;
    font-size: 20px;
    margin-top: 5px;
  }

  &.smaller {
    padding: 0px 40px;
    background-color: rgba(53, 71, 91, 0.7);

    .logo {
      height: 40px;

      &.before {
        display: none;
      }

      &.after {
        margin-top: 6px;
        display: inline-block;
      }
    }

    nav {
      a {
        color: white;
      }
    }

  }

  &.mobile {
    .links {
      margin-top: 0;
      float: none;
    }
    .link-container {
      text-align: center;
    }
  }

}

nav {
  img.logo {
    height: 50px;
    transition: all 0.6s ease;
  }
  .links {
    float: right;
    margin-top: 15px;
    transition: all 0.4s ease;
  }
  a {
    color: white;
    margin: 0 8px;
    font-size: 16px;

    &.signup {
      padding: 2px;
      font-weight: bold;
      border-bottom: 1px solid;
    }
  }
  &.light { // on white bg page
    a {
      color: $color-blue;
    }
  }
}

.thankyou {
  text-align: center;
  padding-top: 25px;
}

.email-signup {
  width: 500px;
  margin: 0 auto;
  padding: 10px 0 40px;

  h3 {
    padding: 0 10px;
    color: $color-blue;
  }

  select {
    width: 100%;
  }

  label {
    cursor: pointer;

    input {
      outline: none;
      display: block;
      line-height: 1;
      margin-top: 7px;
      min-height: 25px;
      border-radius: 2px;
      padding: 8px 12px 4px;
      width: calc(100% - 25px); // for padding
      border: 1px solid #ccc;
      font-family: $font-family;

      &:disabled {
        cursor: not-allowed;
        background-color: #f3f3f3;
      }

      &:focus {
        border-color: $color-blue;
      }
    }
  }

  button {
    float: right;
    min-width: 100px;
    margin-top: 30px;
    padding: 10px 20px;
    background-color: $color-blue;
  }
}


@media screen and (max-width: 950px) {
  nav.grid {
    .unit {
      width: 100%;
    }
  }
}
@media screen and (max-width: 568px) {
  .email-signup {
    width: 100%;
    padding: 10px;

    h3 {
      padding: 0;
      margin: 5px 0;
    }

    .cta {
      text-align: center;

      button {
        float: none;
        margin-top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// apps/comps/header.vue